import styled, { css } from 'styled-components';

import Text from 'components/Text';
import VisuallyHidden from 'components/VisuallyHidden';
import colors from 'utils/colors';

const paddingSize = 2;

export const Wrapper = styled.div`
  position: relative;
`;

export const HiddenCheckbox = styled(VisuallyHidden)`
  bottom: 0;
`;

export const TextWrapper = styled(Text.Body)<{ type: 'sub' | 'heading' }>`
  font-size: 1rem;
  line-height: 1.2em;
  font-weight: ${({ type }) => (type === 'sub' ? 'normal' : 'bold')};
  margin: 5px 0 0;
  max-width: 100%;
`;

export const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: baseline;
`;

export const TickIndicator = styled.div`
  position: absolute;
  top: -12px;
  right: -12px;
  width: 25px;
  height: 25px;
`;

export const Pill = styled.label<{
  selected?: boolean;
  backgroundColor: string;
  borderColor: string;
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: ${({ selected, borderColor }) =>
    selected ? `2px solid ${borderColor}` : '1px solid #3c4a60'};
  border-radius: 2px;
  width: 100%;
  min-height: 80px;
  margin: 8px 0;
  padding: ${paddingSize}px 5px ${paddingSize}px;
  cursor: pointer;
  box-sizing: border-box;
  background: ${({ selected, backgroundColor }) => {
    if (!selected) {
      return 'none';
    }
    return backgroundColor;
  }};
  outline: 0px solid ${colors.orange50};
  outline-offset: 0px;
  transition: outline 0.1s ease-out, outline-offset 0.1s ease-out;

  > ${TextWrapper} {
    max-width: 100%;
    flex: 1 1 auto;
    text-align: left;
    margin: 0;
  }

  &:hover {
    border-width: 2px;
    padding: ${paddingSize - 1}px 4px ${paddingSize - 1}px;
  }

  ${({ selected }) =>
    selected &&
    css`
    border-width: 2px;
    padding: ${paddingSize - 1}px 4px ${paddingSize - 1}px;
  `}

  &:active {
    user-select: none;
  }

  /**
   * Focus state, the :not(:focus-visible) is to unset the styling for mouse navigation
   */
  ${HiddenCheckbox}:focus + & {
    outline: 2px solid ${colors.orange50};
    outline-offset: 4px;
  }

  ${HiddenCheckbox}:focus:not(:focus-visible) + & {
    outline: 0px solid ${colors.orange50};
  }

  /**
    Disabled state
  */
  ${HiddenCheckbox}:disabled + & {
    pointer-events: none;
    background: ${colors.blueGrey10};
  }
`;

export const IconContainer = styled.div<{ iconSize: number }>`
  display: flex;
  > * {
    width: ${props => props.iconSize}px;
    height: ${props => props.iconSize}px;
    flex: 0 0 auto;
    margin: 0 16px;
    user-select: none;

    ${HiddenCheckbox}:disabled + ${Pill} & {
      opacity: 0.25;
    }
  }
`;
